document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.faq-accordion');
    if (accordions) {
        accordions.forEach((accordion) => {
            const items = accordion.querySelectorAll('.faq-accordion__item');



            if (items) {
                items.forEach((item) => {
                    const title = item.querySelector('.faq-accordion__item__header');
                    console.info(title);
                    title.addEventListener('click', (e) => {
                        e.preventDefault();
                        removeActiveItems(items, item);
                        item.classList.toggle('active');
                    });
                });
            }

        });
    }

    function removeActiveItems(items, exclude = null) {
        items.forEach((item) => {
            if (exclude && item == exclude) {
                return;
            }
            item.classList.remove('active');
        });
    }
});

